"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
  The MIT License
  
  Copyright (c) 2017-2019 EclipseSource Munich
  https://github.com/eclipsesource/jsonforms
  
  Permission is hereby granted, free of charge, to any person obtaining a copy
  of this software and associated documentation files (the "Software"), to deal
  in the Software without restriction, including without limitation the rights
  to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
  copies of the Software, and to permit persons to whom the Software is
  furnished to do so, subject to the following conditions:
  
  The above copyright notice and this permission notice shall be included in
  all copies or substantial portions of the Software.
  
  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
  IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
  FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
  AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
  LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
  OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
  THE SOFTWARE.
*/
var react_1 = __importDefault(require("react"));
var core_1 = require("@jsonforms/core");
var core_2 = require("@material-ui/core");
var react_2 = require("@jsonforms/react");
var TextField_1 = __importDefault(require("@material-ui/core/TextField"));
var merge_1 = __importDefault(require("lodash/merge"));
var MaterialNativeControl = /** @class */ (function (_super) {
    __extends(MaterialNativeControl, _super);
    function MaterialNativeControl() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MaterialNativeControl.prototype.render = function () {
        var _a = this.props, id = _a.id, errors = _a.errors, label = _a.label, schema = _a.schema, description = _a.description, enabled = _a.enabled, visible = _a.visible, required = _a.required, path = _a.path, handleChange = _a.handleChange, data = _a.data, config = _a.config;
        var isValid = errors.length === 0;
        var appliedUiSchemaOptions = merge_1.default({}, config, this.props.uischema.options);
        var onChange = function (ev) { return handleChange(path, ev.target.value); };
        var fieldType = schema.format;
        var showDescription = !core_1.isDescriptionHidden(visible, description, this.state.isFocused, appliedUiSchemaOptions.showUnfocusedDescription);
        return (react_1.default.createElement(core_2.Hidden, { xsUp: !visible },
            react_1.default.createElement(TextField_1.default, { id: id + '-input', label: core_1.computeLabel(core_1.isPlainLabel(label) ? label : label.default, required, appliedUiSchemaOptions.hideRequiredAsterisk), type: fieldType, error: !isValid, disabled: !enabled, fullWidth: !appliedUiSchemaOptions.trim, onFocus: this.onFocus, onBlur: this.onBlur, helperText: !isValid ? errors : showDescription ? description : null, InputLabelProps: { shrink: true }, value: data, onChange: onChange })));
    };
    return MaterialNativeControl;
}(react_2.Control));
exports.MaterialNativeControl = MaterialNativeControl;
exports.materialNativeControlTester = core_1.rankWith(2, core_1.or(core_1.isDateControl, core_1.isTimeControl));
exports.default = react_2.withJsonFormsControlProps(MaterialNativeControl);
//# sourceMappingURL=MaterialNativeControl.js.map